import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'Components/UI/_Legacy'

import noop from 'lodash/noop'

import ButtonIcon from './styles'

function ActionButton({ icon, text, width, link, onClick }) {
  const content = (
    <>
      {text}
      {icon ? <ButtonIcon /> : null}
    </>
  )

  // Callers can omit `link` — some legacy CTAs do, and the component already
  // wraps this in a real <button> that carries the click handler. Rendering an
  // href-less <a> there gave Lighthouse an uncrawlable anchor; rendering a
  // <button> would nest one button inside another, which the HTML parser
  // unnests and React then fails to hydrate. A span keeps the styling, stays
  // valid inside the outer button, and leaves behaviour untouched.
  if (!link) {
    return (
      <Button as="span" blueprint width={width} onClick={onClick}>
        {content}
      </Button>
    )
  }

  return (
    <Button.Link blueprint href={link} width={width} onClick={onClick}>
      {content}
    </Button.Link>
  )
}

ActionButton.defaultProps = {
  icon: false,
  width: '100%',
  link: null,
  onClick: noop,
}

ActionButton.propTypes = {
  icon: PropTypes.bool,
  link: PropTypes.string,
  text: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
}

export default ActionButton
